import React from "react";
import DateHelper from "../DateHelper/DateHelper";
import numeral from "numeral";
import { differenceInCalendarDays } from "date-fns";

export default class BookingReservationSegment extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * Render functions
   */

  render() {
    var total_guest_count = this.getTotalGuestCount();
    if (this.props.portal) {
      var check_in_date = DateHelper.parseDateFromBackend(
        this.props.reservation_segment.check_in_date
      );
      var check_out_date = DateHelper.parseDateFromBackend(
        this.props.reservation_segment.check_out_date
      );
      var duration =
        check_out_date && check_in_date
          ? differenceInCalendarDays(check_out_date, check_in_date)
          : null;
    } else {
      var duration =
        this.props.reservation_segment.check_out_date &&
        this.props.reservation_segment.check_in_date
          ? differenceInCalendarDays(
              DateHelper.parseDateFromBackend(
                this.props.reservation_segment.check_out_date
              ),
              DateHelper.parseDateFromBackend(
                this.props.reservation_segment.check_in_date
              )
            )
          : null;
    }

    var products = this.renderProducts(this.props.reservation_segment.rate);

    return (
      <div
        className={`BookingReservationSegment ${
          this.props.reservation_segment.id == this.props.reservation_segment_id
            ? "BookingReservationSegmentSelected"
            : ""
        }`}
      >
        <div className="RoomTypeName" style={{ padding: "0.5rem" }}>
          <div className="DateSummary">
            <table className="table pricing-table">
              <tbody>
                <tr>
                  <td colSpan="2">
                    <strong>
                      {this.props.reservation_segment.room_type.name}
                    </strong>
                    {typeof this.props.onRemoveReservationSegment !==
                    "undefined" ? (
                      <a
                        href="#"
                        className="remove-segment"
                        onClick={this.props.onRemoveReservationSegment.bind(
                          this,
                          this.props.reservation_segment.id
                        )}
                      >
                        <span className="ss-trash"></span>
                      </a>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span style={{ fontWeight: "normal" }}>
                      {this.props.reservation_segment.rate.name}
                    </span>
                    
                    {
                      this.props.reservation_segment.room_type.type_of_booking !== 'daily' && (
                        <>
                          ,{" "}
                          {duration === 1
                            ? I18n.t("num_night", { num: duration })
                            : I18n.t("num_nights", { num: duration })}
                        </>
                      )
                    }

                    , {total_guest_count}{" "}
                    {total_guest_count === 1
                      ? I18n.t("guest").toLowerCase()
                      : I18n.t("guests").toLowerCase()}

                    {
                      this.props.reservation_segment.room_type.type_of_booking === 'daily' ? (
                        <div className="reservation-segment-date-range">
                          {DateHelper.printDateToScreen(
                            this.props.reservation_segment.check_in_date,
                            this.props.date_format
                          )}
                        </div>
                      ) : (
                        <div className="reservation-segment-date-range">
                          (
                          {DateHelper.printDateToScreen(
                            this.props.reservation_segment.check_in_date,
                            this.props.date_format
                          )}{" "}
                          -{" "}
                          {DateHelper.printDateToScreen(
                            this.props.reservation_segment.check_out_date,
                            this.props.date_format
                          )}
                          )
                        </div>
                      )
                    }

                    {this.props.reservation_segment.rate.rate_products &&
                    this.props.reservation_segment.rate.rate_products.length ? (
                      <div>
                        <label>{I18n.t("includes")}:</label>
                        <ul>{products}</ul>
                      </div>
                    ) : null}
                  </td>


                  <td style={{ fontWeight: "normal" }} className="text-right">
                    {this.props.currency.symbol}
                    {numeral(
                      ((this.props.reservation_segment
                        .subtotal_amount -
                        this.props.reservation_segment
                          .add_ons_subtotal_amount) *
                        this.props.currency.exchange_rate) /
                        100
                    ).format(this.props.number_format)}
                  </td>
                </tr>
                {this.renderAddOns()}
                {this.props.reservation_segment.taxes_amount ? (
                  <tr>
                    <td className="text-left amounts">
                      <span
                        title={this.renderTaxOrFeesBreakdown(
                          this.props.reservation_segment.taxes
                        )}
                        style={{
                          borderBottom: "1px solid #AFAFAF",
                          cursor: "pointer",
                        }}
                      >
                        {I18n.t("taxes")}
                      </span>
                    </td>
                    <td className="text-right amounts">
                      {this.props.currency.symbol}
                      {numeral(
                        (this.props.reservation_segment.taxes_amount *
                          this.props.currency.exchange_rate) /
                          100
                      ).format(this.props.number_format)}
                    </td>
                  </tr>
                ) : null}
                {this.props.reservation_segment.fees_amount ? (
                  <tr>
                    <td className="text-left amounts">
                      <span
                        title={this.renderTaxOrFeesBreakdown(
                          this.props.reservation_segment.fees
                        )}
                        style={{
                          borderBottom: "1px solid #AFAFAF",
                          cursor: "pointer",
                        }}
                      >
                        {I18n.t("fees")}
                      </span>
                    </td>
                    <td className="text-right amounts">
                      {this.props.currency.symbol}
                      {numeral(
                        (this.props.reservation_segment.fees_amount *
                          this.props.currency.exchange_rate) /
                          100
                      ).format(this.props.number_format)}
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  renderTaxOrFeesBreakdown(arr) {
    if (arr && arr.map) {
      return arr
        .map((tax) => {
          return (
            "<div class=breakdown><span class=first>" +
            tax.name +
            ":</span><span class=second>" +
            this.props.currency.symbol +
            numeral(tax.total_amount / 100).format(this.props.number_format) +
            "</span></div>"
          );
        })
        .join("");
    }
  }

  renderAddOns() {
    var self = this;
    var add_ons = [];
    if (self.props.reservation_segment.reservation_segment_add_ons) {
      for (var i = 0, ilen = self.props.reservation_segment.reservation_segment_add_ons.length; i < ilen; i++) {
        var reservation_segment_add_on = self.props.reservation_segment.reservation_segment_add_ons[i];
        var { product_id, name, quantity, subtotal_amount } = reservation_segment_add_on;

        add_ons.push(
          <tr key={product_id}>
            <td>
              {name}
              {quantity > 1 ? <span> &times; {quantity}</span> : ""}
            </td>
            <td style={{ fontWeight: "normal" }} className="text-right">
              {self.props.currency.symbol}
              {numeral(
                (subtotal_amount *
                  self.props.currency.exchange_rate) /
                  100
              ).format(self.props.number_format)}
            </td>
          </tr>
        );
      }
    }

    return add_ons;
  }

  renderProducts(rate) {
    var products = [];
    if (rate.rate_products && rate.rate_products.length) {
      rate.rate_products.map((rate_product) => {
        products.push(
          <li key={rate_product.name}>
            {rate_product.quantity} {rate_product.name}
          </li>
        );
      });
    }
    return products;
  }

  /**
   * Helper functions
   */

  getTotalGuestCount() {
    var count = 0;
    // console.log('reservation_segment',this.props.reservation_segment);
  
    if (this.props.reservation_segment.reservation_segment_guest_types) {
      for (
        var i = 0, ilen = this.props.reservation_segment.reservation_segment_guest_types.length; i < ilen; i++ ) {
        count =
          count +
          this.props.reservation_segment.reservation_segment_guest_types[i]
            .number_of_guests;
      }
    }
   
    return count;
  }
}
